<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="MATERIAL_KIND_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="materialKindCd"
            label="자재구분"
            v-model="searchParam.materialKindCd"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="materialTypeTable"
      title="자재 분류"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columnSetting="false"
      :isExcelDown="false"
      :isFullScreen="false"
      rowKey="materialTypeCd"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "material-type-pop",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: "single",
        plantCd: "",
      }),
    },
    reviewCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listUrl: "",
      grid: {
        merge: [
          { index: 0, colName: "materialKindName" },
          { index: 1, colName: "upMaterialTypeName" },
        ],
        columns: [
          {
            name: "materialKindName",
            field: "materialKindName",
            label: "자재구분",
            align: "center",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "upMaterialTypeName",
            field: "upMaterialTypeName",
            label: "자재 대분류",
            align: "left",
            sortable: false,
          },
          {
            name: "materialTypeName",
            field: "materialTypeName",
            label: "자재 중분류",
            align: "left",
            sortable: false,
          },
        ],
        data: [],
        height: "100%",
      },
      searchParam: {
        materialKindCd: null,
        delFlag: "N",
        popFlag: "Y",
      },
      editable: true,
      searchUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 50;
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + "px";
    },
  },
  methods: {
    init() {
      this.listUrl = selectConfig.mdm.mam.material.type.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["materialTypeTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "자재분류를 선택하세요.", // 자재분류를 선택하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
